document.addEventListener('DOMContentLoaded', () => {
	const contentSections = document.querySelectorAll('div.service')

	function callback(entries, observer) {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const button = document.querySelector(
					`.service.button[href="#${entry.target.id}"]`
				)
				button.classList.add('active')
			} else {
				const button = document.querySelector(
					`.service.button[href="#${entry.target.id}"]`
				)
				button.classList.remove('active')
			}
		})
	}
	const observer = new IntersectionObserver(callback)

	contentSections.forEach(section => {
		observer.observe(section)
	})
})
